<template>
	<div>
		<div class="container">
			<div class="handle-box">
				<el-select size="small" v-if="isAdmin" @change="agentChange" v-model="query.agentId" filterable
					clearable placeholder="代理商" class="handle-select mr10" style="width: 260px">
					<el-option v-for="item in agents" :key="item.value" :label="item.label"
						:value="item.value"></el-option>
				</el-select>
				<el-select size="small" v-if="isAdmin || isAgent" v-model="query.companyId" filterable clearable
					placeholder="企业" class="handle-select mr10" style="width: 260px">
					<el-option v-for="item in companys" :key="item.value" :label="item.label"
						:value="item.value"></el-option>
				</el-select>
				<el-select size="small" v-model="query.cardsId" filterable clearable placeholder="请选择品牌"
					style="width: 120px;margin-right: 10px;">
					<el-option v-for="item in cardTypeList" :key="item.label" :label="item.value"
						:value="item.label"></el-option>
				</el-select>
				<el-input size="small" v-model="query.userPhone" clearable maxlength="12" placeholder="用户"
					style="width: 180px;" class="handle-input mr10"></el-input>
				<el-date-picker size="small" v-model="timeArr" type="daterange" unlink-panels range-separator="至"
					start-placeholder="开始日期" end-placeholder="结束日期" class="m_r_10"></el-date-picker>
				<el-button size="small" type="primary" :class="[theme]" icon="el-icon-search"
					@click="getData">搜索</el-button>
			</div>
			<el-table :data="tableData" border class="table" ref="multipleTable" header-cell-class-name="table-header"
				max-height="600" @selection-change="handleSelectionChange"
				:header-cell-style="{ 'text-align': 'center' }" :row-style="{ height: '20px' }"
				:cell-style="{ padding: '6px' }" stripe v-loading="loading">
				<el-table-column type="selection" width="55" align="center"></el-table-column>
				<el-table-column prop="agentName" label="代理商" align="center" width="180"
					v-if="isAdmin"></el-table-column>
				<el-table-column prop="companyName" label="企业" align="center" width="180"
					v-if="isAdmin||isAgent"></el-table-column>
				<el-table-column prop="userPhone" label="用户名" align="center"></el-table-column>
				<el-table-column prop="cardName" label="品牌" align="center"></el-table-column>
				<el-table-column prop="whiteList" label="录入地址" align="center"></el-table-column>
				<el-table-column prop="currentAddress" label="登录地址" align="center"></el-table-column>
				<el-table-column prop="type" label="登录端口" align="center"></el-table-column>
				<el-table-column prop="ip" label="登录IP" align="center"></el-table-column>
				<el-table-column prop="createdAt" label="异常时间" align="center"></el-table-column>
			</el-table>
			<div class="pagination">
				<el-pagination background layout="total, sizes, prev, pager, next, jumper"
					:current-page="query.pageIndex" :page-sizes="[10, 20, 50, 100, 200, 500]"
					:page-size="query.pageSize" :total="pageTotal" @size-change="handleSizeChange"
					@current-change="handlePageChange"></el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		SIPaddressErrList,
		fetchDepartment
	} from '../../api/index.js';
	import {
		fetchAgent
	} from '../../api/agentIndex.js';
	import {
		fetchCompanyByAgentId,
		fetchDefaultCompanies
	} from '../../api/companyIndex';
	import {
		getCardType
	} from '../../api/cardType.js';
	export default {
		name: 'addressErrList',
		data() {
			return {
				loading: false,
				theme: localStorage.getItem('theme'),
				theme3: localStorage.getItem('theme3'),
				theme8: localStorage.getItem('theme8'),
				query: {
					userId: localStorage.getItem('user'),
					agentId: '',
					companyId: '',
					userPhone: '',
					startTime: '',
					endTime: '',
					cardsId: '',
					pageIndex: 1,
					pageSize: 10,
				},
				cardTypeList: [],
				agents: [],
				companys: [],
				tableData: [],
				multipleSelection: [],
				isAdmin: false,
				isAgent: false,
				isNormal: false,
				pageTotal: 0,
				role: '',
				timeArr: []
			};
		},
		created() {
			this.role = localStorage.getItem('ms_role');
			if (this.role === 'admin') {
				this.isAdmin = true;
			}
			if (this.role == 'agent') {
				this.isAgent = true;
			}
			if (this.role == 'normal') {
				this.isNormal = true;
			}
			this.init();
			getCardType('').then(res => {
				this.cardTypeList = res.data;
			});
			this.getData();
			this.updatePaginationStyle();
		},
		methods: {
			updatePaginationStyle() {
				let pagination = document.getElementById('pagination');
				if (!pagination) {
					pagination = document.createElement('style');
					pagination.id = 'dynamic-tab-style';
					document.head.appendChild(pagination);
				}
				pagination.innerHTML = `
				    .el-pager .active {
				        background-color: ${this.theme8} !important;
						color: #fff !important;
				    }
					.el-pager .number:hover {
				        color: ${this.theme8} !important;
				    }
					.el-pager .active:hover {
					    color: #fff !important;
					}
					.el-pager .more:hover {
					    color: ${this.theme8} !important;
					}
				`;
			},
			getData() {
				this.loading = true;
				SIPaddressErrList(this.query).then(res => {
					this.loading = false;
					if (res?.code === 200) {
						this.tableData = res.data.list;
						this.pageTotal = res.data.total;
					} else {
						this.$message.error(res.message);
					}
				});
			},
			// 多选操作
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
			getTime(e) {
				this.statisticsShow = e;
				this.getData();
			},
			init() {
				fetchAgent(localStorage.getItem('user')).then(res => {
					this.agents = res.data;
				});
				this.getfetchDefaultCompanies();
			},
			getfetchDefaultCompanies() {
				this.query.companyId = '';
				let data = {
					currentUserId: localStorage.getItem('user'),
					subAgentId: this.query.subAgentId
				};
				fetchDefaultCompanies(data).then(res => {
					if (this.role == 'company' || this.role == 'department') {
						let data = {
							companyId: '',
							currentUserId: localStorage.getItem('user')
						};
						fetchDepartment(data).then(res => {
							this.departments = res.data;
						});
					} else {
						this.companys = res.data;
					}
				});
			},

			agentChange(agentId) {
				this.query.agentId = agentId;
				this.query.companyId = '';
				this.query.departmentId = '';
				this.query.packageMinutes = '';
				this.packageList = [];
				if (agentId) {
					let data = {
						subAgent: JSON.parse(localStorage.getItem('subAgent').toLowerCase()),
						agentId: agentId
					};
					fetchCompanyByAgentId(data).then(res => {
						this.companys = res.data;
					});
				} else {
					this.departments = [];
				}
			},
			// //导出
			// handleDownload() {
			// 	this.loading = true;
			// 	this.query.company = localStorage.getItem('company');
			// 	aaa(this.query).then(res => {
			// 		if (res.type == 'application/json') {
			// 			return this.$message.error(res.message)
			// 		}
			// 		const blob = new Blob([res], {
			// 			type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
			// 		});
			// 		let downloadElement = document.createElement('a');
			// 		let href = window.URL.createObjectURL(blob);
			// 		downloadElement.href = href;
			// 		let fileName = '客质精控' + '.xlsx';
			// 		downloadElement.download = fileName;
			// 		document.body.appendChild(downloadElement);
			// 		downloadElement.click();
			// 		document.body.removeChild(downloadElement);
			// 		window.URL.revokeObjectURL(href);
			// 		this.loading = false;
			// 	});
			// },
		}
	};
</script>

<style scoped>
	.handle-box {
		margin-bottom: 20px;
	}
</style>